import { Directive, Input, OnInit, OnChanges, OnDestroy, SimpleChanges, Inject } from "@angular/core";
import { AgentKitService } from "../core/agent-kit.service";
import type { Context } from "@ag-ui/client";

@Directive({
  selector: "[agentContext]",
  standalone: true,
})
export class AgentContextDirective implements OnInit, OnChanges, OnDestroy {
  private contextId?: string;

  constructor(@Inject(AgentKitService) private readonly agentKit: AgentKitService) {}

  @Input("agentContext") context?: Context;

  @Input() description?: string;

  @Input() value?: any;

  ngOnInit(): void {
    this.addContext();
  }

  ngOnChanges(changes: SimpleChanges): void {
    const hasContextChange = "context" in changes;
    const hasDescriptionChange = "description" in changes;
    const hasValueChange = "value" in changes;

    if (hasContextChange || hasDescriptionChange || hasValueChange) {
      if (this.contextId) {
        this.updateContext();
      }
    }
  }

  ngOnDestroy(): void {
    this.removeContext();
  }

  private addContext(): void {
    const contextToAdd = this.getContext();

    if (contextToAdd) {
      this.contextId = this.agentKit.core.addContext(contextToAdd);
    }
  }

  private updateContext(): void {
    this.removeContext();
    this.addContext();
  }

  private removeContext(): void {
    if (this.contextId) {
      this.agentKit.core.removeContext(this.contextId);
      this.contextId = undefined;
    }
  }

  private getContext(): Context | null {
    if (this.context) {
      return this.context;
    }

    if (this.description !== undefined && this.value !== undefined) {
      return {
        description: this.description,
        value: this.value,
      };
    }

    return null;
  }
}
